import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { Errors, Input, MoneyInput } from '..//index.js';
import BankAccountDetails from '../CreditorInfo/BankAccountDetails.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import q from '@debbie/cortex/dist/query.js';
import { creditorsEntity } from '@debbie/cortex/dist/creditors/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
const CreditorEconomyBillingSettings = (props) => {
    const { creditor } = props;
    const lang = useSelector((s) => s.lang);
    const [paymentTerms, setPaymentTerms] = useState(creditor.paymentTerms);
    const [minAmount, setMinAmount] = useState(creditor.minimumBillingLimit);
    const paymentDaysChanged = typeof paymentTerms.paymentDays === 'number' &&
        paymentTerms.paymentDays != creditor.paymentTerms.paymentDays;
    const submitter = useMutation((update) => creditorsAPI.update(creditor.creditorId, update), {
        onSuccess: async () => {
            q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, lang.creditors.billingRecipients),
        React.createElement("p", null,
            lang.creditors.billingRecipientsDescription,
            ":",
            ' ',
            React.createElement("code", null, "john@example.com;tim@example.com")),
        React.createElement(BillingEmail, { creditor: creditor, type: "to" }),
        React.createElement(BillingEmail, { creditor: creditor, type: "cc" }),
        React.createElement(BillingEmail, { creditor: creditor, type: "bcc" }),
        React.createElement("h3", null, lang.creditors.paymentTerms),
        React.createElement(Input, { placeholder: lang.creditors.paymentDays, value: paymentTerms.paymentDays, onKeyDown: async (e) => {
                if (e.key === 'Enter' && paymentDaysChanged) {
                    await creditorsAPI.update(creditor.creditorId, {
                        paymentTerms,
                    });
                    q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
                }
            }, onChange: (e) => setPaymentTerms({
                paymentDays: Number(e.target.value),
            }), type: "number", button: paymentDaysChanged
                ? {
                    onClick: async () => {
                        await creditorsAPI.update(creditor.creditorId, {
                            paymentTerms,
                        });
                        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
                    },
                    value: lang.inputs.save,
                }
                : undefined }),
        React.createElement(BankAccountDetails, { creditorId: creditor.creditorId }),
        React.createElement("h3", null, "Minimumsgr\u00E6nse for sagsafregning"),
        React.createElement(MoneyInput, { placeholder: lang.economy.amount, disabled: submitter.isLoading, allowNull: true, value: minAmount, onChange: (amount) => {
                setMinAmount(amount);
            }, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    submitter.mutate({
                        minimumBillingLimit: minAmount,
                    });
                }
            } }),
        submitter.isError && submitter.error instanceof Error ? (React.createElement(Errors, { errors: [submitter.error.message] })) : null));
};
export default CreditorEconomyBillingSettings;
const BillingEmail = (props) => {
    const { creditor } = props;
    const lang = useSelector((s) => s.lang);
    const [_email, setEmail] = useState(null);
    const email = _email === null
        ? (creditor &&
            creditor.billingEmails &&
            creditor.billingEmails[props.type]) ||
            ''
        : _email;
    const save = async () => {
        try {
            await creditorsAPI.update(creditor.creditorId, {
                // @ts-ignore
                billingEmails: {
                    ...creditor.billingEmails,
                    [props.type]: email.trim() || null,
                },
            });
            q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
        }
        catch (error) {
            alert(error);
        }
    };
    const changed = _email !== null &&
        _email !== (creditor?.billingEmails && creditor?.billingEmails[props.type]);
    return (React.createElement(Input, { placeholder: props.type, value: email, onChange: (e) => {
            setEmail(e.target.value);
        }, onKeyDown: (e) => {
            if (e.key === 'Enter' && changed) {
                save();
            }
        }, button: changed
            ? {
                value: lang.inputs.save,
                onClick: () => save(),
            }
            : undefined }));
};
//# sourceMappingURL=CreditorEconomyBillingSettings.js.map